module.exports = __webpack_public_path__ + "img/num_project.63856435.svg";